export const isNul = (value) => value === null;

export const isUndefined = (value) => value === undefined;

export const isDefined = (value) => !isUndefined(value) && !isNul(value);

export const isString = (value) => typeof value === "string";

export const isNumber = (value) => typeof value === "number";

export const isFunction = (value) =>
  typeof value === "function" || value instanceof Function;

export const isObject = (value) => {
  const type = typeof value;
  return (
    !isNul(value) &&
    (type === "object" || type === "function") &&
    !Array.isArray(value)
  );
};

export const p = (value) => parseInt(value);

export const isEmptyObject = (value) =>
  isObject(value) && Object.entries(value).length === 0;

export const isArray = (value) => Array.isArray(value);

export const isArrayLength = (value) => Array.isArray(value) && value.length;

export const isArrayPopulated = (value) =>
  Array.isArray(value) && value.length >= 1;

export const isSubArrayLength = (value, arr) =>
  value && Array.isArray(arr) && arr.length;

export const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const checkPopulated = (field) => {
  if (typeof field === "object") {
    console.log("is outer object", field);
    const isArray = Array.isArray(field);
    if (isArray) {
      console.log("is Array", field);
      return field.length ? field : [];
    } else {
      console.log("is Object", field);
      return isObject(field) && Object.entries(field).length ? field : {};
    }
  }
  if (typeof field === "boolean") {
    return field;
  } else {
    return field === "" || field === undefined ? "" : field;
  }

  // switch (field) {
  //   case typeof "object":
  //     return field === undefined || Object.entries(field).length === 0
  //       ? {}
  //       : field;
  //   case typeof "string":
  //     return field === undefined || field === "" ? "" : field;
  //   case typeof "number":
  //     return field == undefined || field === "" ? "" : field;
  //   case typeof "array":
  //     return field === undefined || field.length === 0 ? [] : field;
  //   default:
  //     return "";
  // }
};
